import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useFormik } from "formik";
import { toast } from "react-toastify";

import "./ContactForm.css";
import { passwordResetSchema } from "./validations";
import API, { AppId } from "../../config";

const ContactForm = ({ helpType }) => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const onSubmit = async (values, actions) => {
    try {
      setLoading(true);
      console.log("API>>", API);

      const response = await axios.post(`${API}/contact-us`, {
        name: values.contactName,
        email: values.email,
        phone: values.phone,
        messages: values.message,
      });

      // const response = await axios.post(
      //   `https://nimble-byte-backend.azurewebsites.net/api/Emailing/EmailEquiry`,
      //   {
      //     Name: values.contactName,
      //     SenderEmail: values.email,
      //     Phone: values.phone,
      //     Message: values.message,
      //     ReceiverEmail: "", //[optional]
      //     AppId
      //   }
      // );

      console.log("response>>>", response);
      if (!response.data.success) {
        toast.error(response.data.message);
        setLoading(false);
      } else {
        toast.success(response.data.message);
        setLoading(false);
        navigate("/");
      }
    } catch (err) {
      console.log(err);
      toast.error("Something went wrong. Try again.");
      setLoading(false);
    }
  };

  const {
    values,
    errors,
    isSubmitting,
    handleBlur,
    handleChange,
    touched,
    handleSubmit,
    isValid,
    dirty,
  } = useFormik({
    initialValues: {
      contactName: "",
      email: "",
      phone: "",
      message: "",
    },
    validationSchema: passwordResetSchema,
    onSubmit,
  });

  const isFormEmpty =
    !values.contactName.trim() ||
    !values.email.trim() ||
    !values.phone.trim() ||
    !values.message.trim();

  const isButtonDisabled = loading || !isValid || isFormEmpty;

  return (
    <>
      <div className="bd-1 form-container bd-color">
        <div className="contact-form-title text-center">
          <span>Let's Build Something Amazing</span>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-group mt-4">
            <label htmlFor="name" className="control-label contact-form-label1">
              Name
            </label>

            <input
              type="text"
              className="form-control input-details"
             name="contactName"
              id="name"
              value={values.contactName}
              onChange={handleChange}
              onBlur={handleBlur}
              autoFocus
            />

            {errors.contactName && touched.contactName && (
              <p className="mt-0 text-danger">
                <small>
                  <div> {errors.contactName}</div>
                </small>
              </p>
            )}
          </div>
          <div className="form-group mt-4">
            <label
              htmlFor="email"
              className="control-label contact-form-label1"
            >
              Email
            </label>
            <input
              id="email"
              type="email"
              className="form-control input-details"
              name="email"
              value={values.email}
              onChange={handleChange}
              onBlur={handleBlur}
            />
            {errors.email && touched.email && (
              <p className="mt-0 text-danger">
                <small>
                  <div> {errors.email}</div>
                </small>
              </p>
            )}
          </div>
          <div className="form-group mt-4">
            <label
              htmlFor="phone"
              className="control-label contact-form-label1"
            >
              Phone
            </label>
            <input
              id="phone"
              type="tel"
              name="phone"
              className="form-control input-details"
              value={values.phone}
              onChange={handleChange}
              onBlur={handleBlur}
            />
            {errors.phone && touched.phone && (
              <p className="mt-0 text-danger">
                <small>
                  <div> {errors.phone}</div>
                </small>
              </p>
            )}
          </div>
          <div className="form-group mt-4">
            <label
              htmlFor="project-details"
              className="control-label contact-form-label1"
            >
              Project Details
            </label>
            <textarea
              id="project-details"
              className="form-control input-details"
              cols={10}
              rows={5}
              name="message"
              value={values.message}
              onChange={handleChange}
              onBlur={handleBlur}
            />
            {errors.message && touched.message && (
              <p className="mt-0 text-danger">
                <small>
                  <div> {errors.message}</div>
                </small>
              </p>
            )}
          </div>
          <div className="mt-4">
            <button
              type="submit"
              className="contact-button w-100 btn btn-color"
              disabled={isButtonDisabled}
            >
              {loading ? "LOADING..." : "SUBMIT"}
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default ContactForm;
